<template>
  <div class="LmValidatorIcon">
    <lm-material-icon :icon="icon" :class="state" />
  </div>
</template>

<script>
import LmMaterialIcon from '@/components/ui/LmMaterialIcon'
export default {
  name: 'LmValidatorIcon',
  components: {LmMaterialIcon},
  props: {
    state: {
      type: String, // validated | validating | invalid
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {
    icon() {
      if (this.state === 'validated') return 'done'
      else if (this.state === 'validating') return 'data_usage'
      else if (this.state === 'invalid') return 'error'
      else return ''
    }
  }
}
</script>

<style scoped>
.LmValidatorIcon {
  .LmMaterialIcon {
    margin-top: -10px;
    margin-left: 10px;
    &.validated {
      color: theme('colors.highlight');
    }
    &.invalid {
      color: #f44336;
    }
    &.validating {
      animation: rotate 1s infinite linear;
    }
  }
}
</style>
